Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('./color');

var getFont = function getFont(_ref) {
  var fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      _ref$letterSpacing = _ref.letterSpacing,
      letterSpacing = _ref$letterSpacing === undefined ? 0 : _ref$letterSpacing,
      lineHeight = _ref.lineHeight,
      padding = _ref.padding;
  return {
    color: _color.textColor,
    fontFamily: fontFamily,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
    lineHeight: String(lineHeight) + 'px',
    paddingBottom: padding,
    paddingTop: padding
  };
};

var fontFamily = 'BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif';

exports['default'] = {
  fontFamily: fontFamily,

  // weights
  light: {
    fontWeight: 200
  },
  bold: {
    fontWeight: 700
  },

  // size
  tiny: Object.assign({}, getFont({
    fontFamily: fontFamily,
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.4
  })),
  small: Object.assign({}, getFont({
    fontFamily: fontFamily,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.4
  })),
  regular: Object.assign({}, getFont({
    fontFamily: fontFamily,
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.2
  })),
  large: Object.assign({}, getFont({
    fontFamily: fontFamily,
    fontSize: 18,
    lineHeight: 24,
    spacing: 0
  }))
};